__webpack_require__.p = "https://qa.staplesconnect.com/";